import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=17a72abd&scoped=true"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"
import style0 from "./personal.vue?vue&type=style&index=0&id=17a72abd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a72abd",
  null
  
)

export default component.exports